import React from "react";
import { connect } from "react-redux";
import compose from "ramda/src/compose";

import { AlertModal, Button } from "shared/components";
import { closeModal } from "../../services/state/actions";

import Error from "../../assets/svg/error.svg";
import styles from "./styles.css";

const UnavailableSystemModal = ({ system, closeModal }) => (
  <AlertModal
    isOpen={system.unavailable}
    onClose={closeModal}
    title="Sistema indisponível"
    iconMessage="iconTeste"
  >
    <form className={styles.content}>
      <img src={Error} alt="" />
      <p>
        <b>Não foi possível realizar essa ação agora.</b>
        <br />
        Por favor, tente novamente mais tarde.
      </p>
      <br />
      <fieldset className={styles.actions}>
        <Button relevance="normal" callToAction onClick={closeModal}>
          OK
        </Button>
      </fieldset>
    </form>
  </AlertModal>
);

const mapStateToProps = ({ system }) => ({
  system,
});

const enhance = compose(connect(mapStateToProps, { closeModal }));

export default enhance(UnavailableSystemModal);



// WEBPACK FOOTER //
// ./src/components/UnavailableSystemModal/index.js